import { Component, OnInit, Input, Output ,EventEmitter } from '@angular/core';
import { DialogService } from '../dialog/dialog.service';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';
import { InputButtonPopupComponent } from './input-button-popup.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'dhs-input-button',
  templateUrl: './input-button.component.html',
  styleUrls: ['./input-button.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputButtonComponent,
    multi: true,
  }],
  standalone: false
})
export class InputButtonComponent implements OnInit {
  @Input('value') _value: any;
  @Input() resource: string;
  @Input() btnText: string;
  @Input() id: any;
  @Input() buttons: any[] = [];
  @Input() buttonsConfig: any;
  @Input() question:any
  @Output() valueChange = new EventEmitter<any>();
  fields: any = [];
  fieldGroups: any = [];
  formBlocks: any = [];
  listBlocks: any = [];
  items: Array<any> = [];
  activatedResource: string;
  item: any;
  showbtn:boolean = false;
  propagateChange = (_: any) => { };
  onTouched = () => { };
  constructor(private dialogService: DialogService,
    public config: DialogConfig,
    public dialog: DialogRef,
    private baseService: BaseService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedResource = this.route.snapshot.data.decorator ? this.route.snapshot.data.decorator : this.resource;
    this.setButtonVisibility();
    this.baseService.getResourceDef(this.resource, (resourceDef) => {
      if (resourceDef) {
        this.formBlocks = resourceDef.form;
        if (resourceDef.list != null)
          this.listBlocks = resourceDef.list.field;
        this.baseService.getReferredField(resourceDef.form, (response) => {
          this.fieldGroups = response[0];
          this.fieldGroups.fields.sort((a, b) => { return a.order - b.order });
        })
      }
    })
  }

  private setButtonVisibility() {
    if (!this.buttons || this.buttons.length == 0) {
      this.showbtn = false;
      return;
    }

    const buttonConfig = this.buttonsConfig || this.question?.buttons_config;
    if (!buttonConfig) {
      this.showbtn = true;
      return;
    }
    if (!buttonConfig.config_code || !buttonConfig.module_code) {
      this.showbtn = false;
      return;
    }

    this.showbtn = false;
    const queryId = buttonConfig.query_id || 'GET_CONFIG';
    const resource = buttonConfig.resource || 'facility_config_mapping';
    const application = 'facility-management';
    const args = `config_code:${buttonConfig.config_code},module_code:${buttonConfig.module_code}`;
    const cacheKey = `${queryId}:${resource}:${application}:${args}`;

    this.baseService.getWithCache(cacheKey, () => this.baseService.get(queryId, args, resource, application)).subscribe({
      next: (res: any) => {
        this.showbtn = this.isButtonConfigAllowed(res);
      },
      error: (error) => {
        console.error('Error while getting button config', error);
        this.showbtn = false;
      }
    });
  }

  private isButtonConfigAllowed(res: any): boolean {
    const configData = this.getButtonConfigData(res);
    const status = String(configData?.status || configData?.status_name || '').toLowerCase();
    if (!configData || status != 'active') {
      return false;
    }

    const value = configData.config_value || configData.config || configData.dropdown_key || configData.dropdown_value;
    if (typeof value == 'boolean') {
      return value;
    }
    if (typeof value == 'string') {
      return ['yes', 'true', 'y', '1'].includes(value.toLowerCase());
    }
    return false;
  }

  private getButtonConfigData(res: any): any {
    if (Array.isArray(res)) {
      return res.find((item) => String(item?.status || item?.status_name || '').toLowerCase() == 'active') || res[0];
    }
    if (Array.isArray(res?.data)) {
      return res.data.find((item) => String(item?.status || item?.status_name || '').toLowerCase() == 'active') || res.data[0];
    }
    if (Array.isArray(res?.resource)) {
      return res.resource.find((item) => String(item?.status || item?.status_name || '').toLowerCase() == 'active') || res.resource[0];
    }
    if (res?.data && typeof res.data == 'object') {
      return res.data;
    }
    if (res?.resource && typeof res.resource == 'object') {
      return res.resource;
    }
    return res;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.item = val;
    this.propagateChange(val);
  }

  writeValue(value) {
    this._value = value;
    this.item = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private getValue(item: any, field: any) {
    const name = field.name;
    let value = null;

    value = item[name];

    return value;
  }

  openPopup() {
    let obj = { data: { formblocks: this.formBlocks, data: null, activatedResource: this.activatedResource } };
    const ref1 = this.dialogService.open(InputButtonPopupComponent, obj);
    ref1.afterClosed.subscribe(response => {
      console.log('dialog closed', response);
      if (response.result != undefined && response.result) {
        let result = response.result;
        this.items.push(result);
        this.value = result;
      }
    });
    return false;
  }



  onButtonClick(data: any) {
    console.log('Button clicked action:', data.action);
   // this.item = data.action;
   // this.propagateChange(this.item);
    const event = {
      target: {
        value: data.action
      }
    }
    this.valueChange.emit(event);
  }

  onInputChange(value: any) {
    this._value = value;
    this.propagateChange(value);
    this.valueChange.emit({
      target: {
        value: value
      }
    });
  }

   
}
